module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Additional Task Request (Lite)")])], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": _vm.$sessionsStorage.get('allModuleIdMain') || '',
      "jobSeriesBanner": _vm.$sessionsStorage.get('JOBSERIES') || '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard mt-2"
  }, [_c('b-card-text', [_c('b-card', {
    staticClass: "mt-2"
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Assignment Details")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sm gutr mt-1 mb-1"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Job No.")]), _vm._v(" "), _c('th', [_vm._v("Job Date")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("POD")])]), _vm._v(" "), _vm._l((_vm.assignmentRows), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "error",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_c('h6', [_vm._v(_vm._s(item.Job_Series))])]), _vm._v(" "), _c('td', {
      staticClass: "error",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_c('h6', [_vm._v(_vm._s(item.JobDate))])]), _vm._v(" "), _c('td', {
      staticClass: "error",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_c('h6', [_vm._v(_vm._s(item.clientName))])]), _vm._v(" "), _c('td', {
      staticClass: "error",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_c('h6', [_vm._v(_vm._s(item.POD))])])])
  })], 2)]), _vm._v(" "), _c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Additional Task Details")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive table-container mt-1 mb-1"
  }, [_c('table', {
    staticClass: "table table-sm table-bordered table-hover gutr table-sticky"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', {
    staticClass: "text-right",
    staticStyle: {
      "min-width": "120px",
      "width": "120px"
    }
  }, [_c('b-button', {
    attrs: {
      "id": "add-row-btn",
      "size": "sm",
      "variant": "success",
      "disabled": _vm.assignmentData[0] && _vm.assignmentData[0].Job_Series !== _vm.$sessionsStorage.get('JOBSERIES')
    },
    on: {
      "click": _vm.addInvArry
    }
  }, [_c('i', {
    staticClass: "fa fa-plus mr-1"
  }), _vm._v(" Add\n                    ")])], 1), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "60px"
    }
  }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "220px"
    }
  }, [_vm._v("Particulars")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "110px",
      "width": "110px"
    }
  }, [_vm._v("Exp Amount")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "110px",
      "width": "110px"
    }
  }, [_vm._v("Currency")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "160px"
    }
  }, [_vm._v("Bill To Customer")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Selling AMT")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "150px"
    }
  }, [_vm._v("Approval Status")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "220px"
    }
  }, [_vm._v("Remarks")])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [(!_vm.lineADDTaskModalArray.length) ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-3",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("\n                    No additional tasks yet. Click "), _c('strong', [_vm._v("Add")]), _vm._v(" to create a row.\n                  ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.lineADDTaskModalArray), function(itm, idx) {
    return _c('AddTaskRow', {
      key: idx,
      attrs: {
        "item": itm,
        "index": idx,
        "ledgerData": _vm.$store.getters['common/getAllLedgerList'],
        "scCategoryList": _vm.SCCategoryList,
        "isAdminRemovable": _vm.isAdminRemovable,
        "currencies": _vm.currencies
      },
      on: {
        "remove": _vm.removeInvArry,
        "remove-admin": _vm.removeAdditionalTask,
        "alert": _vm.showAlert,
        "change": _vm.onRowChange
      }
    })
  })], 2), _vm._v(" "), (_vm.lineADDTaskModalArray.length) ? _c('tfoot', [_c('tr', {
    staticClass: "bg-light font-weight-bold"
  }, [_c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Totals:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalExpense))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalSelling))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('b-badge', {
    attrs: {
      "variant": _vm.netMargin >= 0 ? 'success' : 'danger'
    }
  }, [_vm._v("Margin: " + _vm._s(_vm.netMargin))])], 1), _vm._v(" "), _c('td', {
    staticClass: "text-right pr-3"
  }, [_vm._v("Rows: " + _vm._s(_vm.lineADDTaskModalArray.length))])])]) : _vm._e()])])]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "5"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "2"
    }
  }, [(_vm.lineADDTaskModalArray.length > 0) ? _c('b-button', {
    staticClass: "mt-3 d-flex align-items-center justify-content-center",
    attrs: {
      "size": "sm",
      "variant": "primary",
      "disabled": _vm.isSubmitting || (_vm.assignmentData[0] && _vm.assignmentData[0].Job_Series !== _vm.$sessionsStorage.get('JOBSERIES'))
    },
    on: {
      "click": _vm.addADDTaskDetail
    }
  }, [(_vm.isSubmitting) ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Save & Submit")])], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "5"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.$sessionsStorage.get('allModuleIdMain')) ? _c('OldExpenseAdditionalTask', {
    attrs: {
      "allModuleId": _vm.$sessionsStorage.get('allModuleIdMain'),
      "type": "additional-task"
    }
  }) : _vm._e(), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopDelete",
    attrs: {
      "md-content-html": _vm.confirmDelete.content,
      "md-ok-text": _vm.confirmDelete.ok,
      "md-cancel-text": _vm.confirmDelete.cancel
    },
    on: {
      "close": _vm.onCloseDeleteConfirm
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25a52252","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/AdditionalTaskLite.vue
// module id = 2468
// module chunks = 0